import React from 'react';
import { useSelector } from 'react-redux';
import { Language } from '../../../utils';
import { Button } from '../../../components';
import makeClasses from '../styles';
import clsx from 'clsx';
import { Alert } from '@material-ui/lab';
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined';
import Markdown from 'markdown-to-jsx';

const Disclaimer = ({ nextStep }) => {
  const classes = makeClasses();

  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));

  const i18n = Language(languageTexts);

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>{i18n.get('Register.StepFormTitle')}</div>
        </div>
        <Alert severity="warning" icon={false} className={clsx(classes.alert, classes.alertWarning, classes.disclaimerAlert)}>
          <div className={classes.alertIconWrapper}>
            <FlagOutlinedIcon className={classes.alertIcon} />
          </div>
          <div>
            <Markdown className={classes.alertBodyText}>
              {i18n.get('Components.OnboardingWarningModal.BodyText')}
            </Markdown>
          </div>
        </Alert>
      </div>
      <div className={clsx(classes.termsWrapper, classes.disclaimerTermsWrapper)}>
        <div
          className={clsx(
            classes.formSubmitContainer,
            classes.formSubmitContainerWithOneButton,
            classes.disclaimerFormSubmitContainer,
          )}
        >
          <Button className={classes.formSubmitButton} onClick={nextStep}>
            {i18n.get('Register.NextButton')}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

Disclaimer.id = 'com.Handy.Register.Disclaimer';
export default Disclaimer;
